import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Card, CardBody } from '../../components/ui/index.js';

/** Compact stat tile used across the role homes. */
export function StatCard({
  label,
  value,
  hint,
  to,
  tone,
}: {
  label: string;
  value: ReactNode;
  hint?: string;
  to?: string;
  tone?: 'success' | 'warning' | 'error';
}) {
  const valueColor =
    tone === 'success'
      ? 'text-success'
      : tone === 'warning'
        ? 'text-warning'
        : tone === 'error'
          ? 'text-error'
          : 'text-text-primary';
  const body = (
    <CardBody>
      <span className="text-xs font-semibold uppercase tracking-wider text-text-muted">
        {label}
      </span>
      <p className={`mt-1 text-2xl font-bold tabular-nums ${valueColor}`}>{value}</p>
      {hint && <span className="text-xs text-text-muted">{hint}</span>}
    </CardBody>
  );
  if (to) {
    return (
      <Link
        to={to}
        className="block rounded-xl focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        <Card className="h-full transition-shadow hover:shadow-md">{body}</Card>
      </Link>
    );
  }
  return <Card className="h-full">{body}</Card>;
}

export function HomeSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-bold text-text-primary">{title}</h2>
      {children}
    </section>
  );
}

export function QuickLinks({ links }: { links: { to: string; label: string }[] }) {
  return (
    <nav aria-label="Quick links" className="flex flex-wrap gap-2">
      {links.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          className="rounded-lg border border-border bg-surface px-3 py-1.5 text-sm text-text-secondary transition-colors hover:bg-bg-subtle focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          {l.label} →
        </Link>
      ))}
    </nav>
  );
}
